"use client";

import * as Sentry from "@sentry/nextjs";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import AppError from "~/components/AppError/AppError";

export default function Error(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { error, reset } = props;

  const pathname = usePathname();
  const location = pathname.split("/")[1];

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <AppError
      error={error}
      reset={reset}
      redirect={{ label: "Home", href: `/${location}/` }}
    />
  );
}
